import { useState } from 'react'
import { useParams, useNavigate, Navigate } from 'react-router-dom'
import { UsersIcon } from '@heroicons/react/24/outline'

import SidePanel from '../SidePanel/SidePanel'
import AuthNavBar from '../Dashboard/AuthNavBar'
import AdminUsers from './AdminUsers'
import useGlobalTheme from '../../hooks/useGlobalTheme'

const MENU = [
	{ name: 'users', label: 'Users', icon: UsersIcon, component: AdminUsers },
]

function Admin() {
	const [isPanelOpen, setIsPanelOpen] = useState(false)
	const navigate = useNavigate()
	const params = useParams()
	const tab = params['*']?.split('/')[0]
	const theme = useGlobalTheme()
	const isLight = theme === 'light'

	if (!tab) {
		return <Navigate to="/admin/users" replace />
	}

	const activeItem = MENU.find(item => item.name === tab) || MENU[0]
	const ActiveComponent = activeItem.component

	return (
		<div className={`min-h-screen ${isLight ? 'bg-white text-gray-700' : 'bg-[#15202b] text-gray-200'}`}>
			<AuthNavBar />
			<SidePanel
				isOpen={isPanelOpen}
				onOpen={() => setIsPanelOpen(true)}
				onClose={() => setIsPanelOpen(false)}
			/>
			<div className="max-w-7xl mx-auto pt-[5vh] pb-8 sm:px-6 lg:px-8">
				<div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-6">
					<nav className="space-y-1">
						<div className={`px-3 py-2 text-xs font-semibold uppercase tracking-wide ${isLight ? 'text-gray-500' : 'text-gray-500'}`}>
							Admin
						</div>
						{MENU.map(item => (
							<div
								key={item.name}
								onClick={() => navigate(`/admin/${item.name}`)}
								className={`px-3 py-2 cursor-pointer rounded-lg transition-colors flex items-center text-sm font-medium ${
									activeItem.name === item.name
										? 'bg-sky-500/10 text-sky-400 ring-1 ring-sky-500/20'
										: isLight
											? 'hover:bg-gray-50 text-gray-700 hover:text-gray-900'
											: 'hover:bg-white/5 text-gray-300 hover:text-gray-100'
								}`}
							>
								<item.icon className="h-5 w-5 mr-2.5" />
								{item.label}
							</div>
						))}
					</nav>
					<div className={`p-6 rounded-lg min-h-[24rem] ${
						isLight
							? 'bg-white ring-1 ring-gray-200 shadow-lg'
							: 'bg-[#1a2634] ring-1 ring-white/10 shadow-[0_0_10px_rgba(59,130,246,0.1)]'
					}`}>
						<ActiveComponent />
					</div>
				</div>
			</div>
		</div>
	)
}

export default Admin
